import type { ActiveGamesState, Slicer } from '../../types';

export const selectors = (slice: Slicer<ActiveGamesState>) => ({
  getGames: () => slice((state) => state.games)
});
